import type { FileAsset, LinkAsset } from "@nlc/shared-types";

import { useDownloadBulkAttachments } from "../../../hooks/useDownloadBulkAttachments.tsx";

export function useAssetDownload() {
  const { mutateAsync: downloadBulkFiles } = useDownloadBulkAttachments();

  const handleDownloadAll = (attachmentList: Array<FileAsset | LinkAsset>) =>
    downloadBulkFiles(
      attachmentList
        .filter((asset) => "file" in asset)
        .map((asset) => asset.attachmentId),
    );

  const handleDownloadSelected = (selectedIds: number[]) =>
    downloadBulkFiles(selectedIds);

  return {
    handleDownloadAll,
    handleDownloadSelected,
  };
}
